import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { IOrderDetailsData } from '../../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { v4 } from 'uuid';

import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';

export const InternalTransferConversions = {
  ACH: (
    ach: IACHDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IInternalTransferDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = ach;
    return {
      type: eDisbursementType.InternalTransfer,
      id: v4(),
      isNew: true,
      amountCents,
      statementFeeId,
      holdback,
      holdbackProperties,
    };
  },
  Wire: (
    wire: IWireDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IInternalTransferDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = wire;
    return {
      type: eDisbursementType.InternalTransfer,
      id: v4(),
      isNew: true,
      amountCents,
      statementFeeId,
      holdback,
      holdbackProperties,
    };
  },
  Check: (
    check: ICheckDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): IInternalTransferDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = check;
    return {
      type: eDisbursementType.InternalTransfer,
      id: v4(),
      isNew: true,
      amountCents,
      statementFeeId,
      holdback,
      holdbackProperties,
    };
  },
};
